import React from 'react';
import { Grid, Card, CardContent, Box, Typography } from '@material-ui/core';
import {
  TrendingUpOutlined as TrendingUpIcon,
  HourglassEmptyOutlined as ComingSoonIcon,
} from '@material-ui/icons';
import { NamespaceGroup } from '../types/metrics.types';
import { MetricItem } from './MetricItem';
import { MAX_PREVIEW_METRICS } from '../constants/primitive-metrics.constants';
import { useMetricCardStyles } from '../styles/metric-card.styles';

interface MetricCardProps {
  section: NamespaceGroup;
  index: number;
  onClick: (section: NamespaceGroup) => void;
}

export const MetricCard = React.memo<MetricCardProps>(({
  section, 
  index, 
  onClick
}) => {
  const classes = useMetricCardStyles();
  const previewMetrics = section.hasData ? section.metrics.slice(0, MAX_PREVIEW_METRICS) : [];
  const hasMoreMetrics = section.hasData && section.metrics.length > MAX_PREVIEW_METRICS;

  const handleClick = () => {
    onClick(section);
  };

  return (
    <Grid item xs={12} sm={6} md={4} key={index}>
      <Card 
        className={`${classes.card}`}
        onClick={handleClick}
      >
        <CardContent className={classes.cardContent}>
          {/* Header */}
          <Box className={classes.header}>
            {section.hasData ? (
              <TrendingUpIcon className={classes.activeIcon} />
            ) : (
              <ComingSoonIcon className={classes.comingSoonIcon} />
            )}
            <Typography variant="h6" className={classes.headerTitle}>
              {section.primitiveName}
            </Typography>
          </Box>

          {/* Content */}
          <Box className={classes.content}>
            {section.hasData ? (
              <>
                {/* Preview Metrics */}
                <Box className={classes.previewMetrics}>
                  {previewMetrics.map((metric, idx) => (
                    <MetricItem key={idx} metric={metric} />
                  ))}
                </Box>
                
                {/* "View more" link */}
                {hasMoreMetrics && (
                  <Typography 
                    variant="body2" 
                    color="primary" 
                    className={classes.viewMoreLink}
                  >
                    View {section.metrics.length - MAX_PREVIEW_METRICS} more...
                  </Typography>
                )}
              </>
            ) : (
              <Box className={classes.comingSoonContainer}>
                <Typography variant="body2" color="textSecondary">
                  Coming Soon
                </Typography>
              </Box>
            )}
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
});

MetricCard.displayName = 'MetricCard';
